export const CORPORATE_USERTYPE = "corporate";
export const CORPORATE_ROLE_ADMIN = "corporate_admin";
export const CORPORATE_ROLE_EMPLOYEE = "corporate_employee";

export const CORPORATE_ROUTES = {
  LOGIN: "/company/login",
  LOGIN_VERIFY: "/company/login/verify",
  REGISTER: "/company/register",
  FORGOT_PASSWORD: "/company/forgot-password",
  RESET_PASSWORD: "/company/reset-password",
  resetPassword: (token) =>
    `/company/reset-password/${encodeURIComponent(String(token || ""))}`,
  PENDING_APPROVAL: "/company/pending-approval",
  INVITATION: "/business/invitation",
  invitationAccept: (token) =>
    `/business/invitation/${encodeURIComponent(String(token || ""))}`,
  DASHBOARD: "/p/company/dashboard",
  EMPLOYEES: "/p/company/employees",
  ORDERS: "/p/company/orders",
  SEARCH: "/p/company/search",
  SEARCH_RESULTS: "/p/company/search/results",
  PACKAGE_PREVIEW: "/p/company/package/preview",
  packageDetails: (packageId) => `/p/company/package/${encodeURIComponent(String(packageId))}`,
  packageCheckout: (packageId) =>
    `/p/company/package/${encodeURIComponent(String(packageId))}/checkout`,
};

export const CORPORATE_NAV_ITEMS = [
  { key: "dashboard", label: "לוח בקרה", path: CORPORATE_ROUTES.DASHBOARD },
  { key: "employees", label: "עובדים", path: CORPORATE_ROUTES.EMPLOYEES, adminOnly: true },
  { key: "orders", label: "הזמנות", path: CORPORATE_ROUTES.ORDERS },
  { key: "search", label: "חיפוש", path: CORPORATE_ROUTES.SEARCH },
];

function filterByAdmin(items, isAdmin) {
  return items.filter((item) => !item.adminOnly || isAdmin);
}

export const CORPORATE_TOP_NAV_ITEMS = [
  { key: "dashboard", label: "לוח בקרה", path: CORPORATE_ROUTES.DASHBOARD, icon: "dashboard", end: true },
  { key: "search", label: "חיפוש", path: CORPORATE_ROUTES.SEARCH, icon: "search" },
  { key: "orders", label: "הזמנות", path: CORPORATE_ROUTES.ORDERS, icon: "orders" },
  { key: "employees", label: "עובדים", path: CORPORATE_ROUTES.EMPLOYEES, icon: "employees", adminOnly: true },
  {
    key: "analytics",
    label: "דוחות",
    path: `${CORPORATE_ROUTES.DASHBOARD}#corp-dashboard-analytics`,
    icon: "reports",
    hash: true,
  },
  {
    key: "benefits",
    label: "הטבות",
    path: `${CORPORATE_ROUTES.DASHBOARD}#corp-dashboard-benefits`,
    icon: "benefits",
    hash: true,
  },
];

export const CORPORATE_MOBILE_NAV_ITEMS = [
  { key: "dashboard", label: "בית", path: CORPORATE_ROUTES.DASHBOARD, icon: "dashboard", end: true },
  { key: "search", label: "חיפוש", path: CORPORATE_ROUTES.SEARCH, icon: "search" },
  { key: "orders", label: "הזמנות", path: CORPORATE_ROUTES.ORDERS, icon: "orders" },
  { key: "employees", label: "עובדים", path: CORPORATE_ROUTES.EMPLOYEES, icon: "employees", adminOnly: true },
  { key: "more", label: "עוד", icon: "more" },
];

export const CORPORATE_MOBILE_MORE_ITEMS = [
  {
    key: "analytics",
    label: "דוחות",
    path: `${CORPORATE_ROUTES.DASHBOARD}#corp-dashboard-analytics`,
    icon: "reports",
  },
  {
    key: "benefits",
    label: "הטבות",
    path: `${CORPORATE_ROUTES.DASHBOARD}#corp-dashboard-benefits`,
    icon: "benefits",
  },
];

export function getCorporateTopNavItems(isAdmin) {
  return filterByAdmin(CORPORATE_TOP_NAV_ITEMS, Boolean(isAdmin));
}

export function getCorporateMobileNavItems(isAdmin) {
  return filterByAdmin(CORPORATE_MOBILE_NAV_ITEMS, Boolean(isAdmin));
}

export function getCorporateMobileMoreItems() {
  return CORPORATE_MOBILE_MORE_ITEMS;
}
